"use client";

import {
  Toaster as ChakraToaster,
  Portal,
  Spinner,
  Stack,
  Text,
  Toast,
  createToaster,
} from "@chakra-ui/react";
import { TriangleAlert } from "lucide-react";
import { AppColors } from "@/styles/colors";

export const toaster = createToaster({
  placement: "bottom-end",
  pauseOnPageIdle: true,
  duration: 4000,
});

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: "4" }}>
        {(toast) => {
          const isStrongWarning = toast.type === "warning-strong";
          const isWarning = toast.type === "warning" || isStrongWarning;

          return (
            <Toast.Root
              width={{ md: "sm" }}
              display="flex"
              alignItems="center"
              paddingX={2}
              paddingY={1}
              bgColor={
                isStrongWarning
                  ? AppColors.WARNING_STRONG_BG
                  : toast.type === "warning"
                    ? AppColors.WARNING_BG
                    : undefined
              }
            >
              {toast.type === "loading" ? (
                <Spinner size="sm" color="blue.solid" />
              ) : isStrongWarning ? (
                <TriangleAlert
                  data-testid="toast-indicator"
                  size={28}
                  strokeWidth={2}
                  style={{ flexShrink: 0, alignSelf: "center" }}
                  color={AppColors.WHITE_SECONDARY}
                />
              ) : (
                <Toast.Indicator
                  data-testid="toast-indicator"
                  color={
                    toast.type === "warning" ? AppColors.WARNING_ICON : undefined
                  }
                />
              )}
              <Stack gap="1" flex="1" maxWidth="100%" padding="10px">
                {toast.title && (
                  <Toast.Title>
                    <Text
                      color={
                        isStrongWarning
                          ? AppColors.WHITE_SECONDARY
                          : isWarning
                            ? AppColors.BLACK_TEXT_SECONDARY
                            : "inherit"
                      }
                    >
                      {toast.title}
                    </Text>
                  </Toast.Title>
                )}
                {toast.description && (
                  <Toast.Description>{toast.description}</Toast.Description>
                )}
              </Stack>
              {toast.action && (
                <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
              )}
              {toast.meta?.closable && (
                <Toast.CloseTrigger data-testid="close-button" />
              )}
            </Toast.Root>
          );
        }}
      </ChakraToaster>
    </Portal>
  );
};
